import { MA_COORDINATES } from '../common/constants.es6';
import MapboxMap from '../common/map/mapbox-map.es6';
import Wa from '../common/wa';

/**
 * Load detail marker page map
 * @param markerCoordinates
 */
export function initializeMap(markerCoordinates) {
    const wrapperElement = document.querySelector('[data-vector-map]');
    if (!wrapperElement) {
        return;
    }

    const map = new MapboxMap(wrapperElement, 'mapbox-map', {
        center: markerCoordinates,
        zoom: 16,
        scrollZoom: false,
        showControls: true,
    });
    map.registerExternalMarker(
        'home-marker',
        '/static/images/meilleursagents-marker@2x.png',
        markerCoordinates,
    );
}

export function domReady() {
    initializeMap(MA_COORDINATES);
    Wa.setTracking();
}
